const ERROR_SHOW_CANCEL_ONBOARDING_CUSTOM_ACTION =
    'GIL189: El usuario ha clicado en el boton que muestra el modal de cancelación de la solicitud de préstamo desde la pantalla de error.',
  ERROR_HIDE_CANCEL_ONBOARDING_CUSTOM_ACTION =
    'GIL190: El usuario ha clicado en el boton que cierra el modal de cancelación de la solicitud de préstamo desde la pantalla de error.',
  ERROR_CANT_CONTINUE_CUSTOM_ACTION =
    'GIL191: El usuario no puede continuar con el proceso de onboarding y va a ser redirigido a Amazon desde la pantalla de error por el siguiente motivo: ',
  ERROR_ONBOARDING_EXPIRED_CUSTOM_ACTION =
    'GIL192: El tiempo para completar el onboarding ha expirado y el usuario va a ser redirigido a Amazon desde la pantalla de error.',
  ERROR_GO_BACK_TO_OPERATIVE_CUSTOM_ACTION =
    'GIL193: El usuario ha decidido volver al flujo operativo actual desde la pantalla de error.',
  ERROR_BIZUM_TIMER_EXPIRED_CUSTOM_ACTION =
    'GIL194: El tiempo para completar el proceso de Bizum ha expirado y el usuario va a ser redirigido al flujo operativo actual.';

export {
  ERROR_SHOW_CANCEL_ONBOARDING_CUSTOM_ACTION,
  ERROR_HIDE_CANCEL_ONBOARDING_CUSTOM_ACTION,
  ERROR_CANT_CONTINUE_CUSTOM_ACTION,
  ERROR_ONBOARDING_EXPIRED_CUSTOM_ACTION,
  ERROR_GO_BACK_TO_OPERATIVE_CUSTOM_ACTION,
  ERROR_BIZUM_TIMER_EXPIRED_CUSTOM_ACTION,
};
